<template>
  <v-toolbar
    id="core-toolbar"
    text
    flat
  >
    <v-toolbar-items>
      <v-btn
        v-if="responsive"
        text
        icon
        @click.stop="onClickBtn"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-toolbar-items>

    <helper-loading />
    <v-menu
      v-if="getWhiteLabel"
      style="display: inline"
      offset-y
      right
      bottom
    >
      <template #activator="{ on }">
        <v-btn
          :disabled="$apollo.loading"
          outlined
          small
          text
          v-on="on"
        >
          {{ getWhiteLabel.name }}
        </v-btn>
      </template>
      <v-sheet dense>
        <v-list-item
          v-for="(w, i) in whiteLabels"
          :key="i"
          dense
          @click="setWhiteLabel(w)"
        >
          <v-list-item-title>{{ w.name }}</v-list-item-title>
        </v-list-item>
      </v-sheet>
    </v-menu>

    <v-spacer />
    <v-toolbar-items v-if="(me === undefined && !getUser) && !$apollo.loading">
      <v-flex py-3>
        <v-btn
          v-if="!$vuetify.breakpoint.xs"
          text
          @click="$router.push('/login')"
        >
          {{ $t("register.logIn") }}
        </v-btn>
      </v-flex>
    </v-toolbar-items>
    <v-toolbar-items v-if="me !== undefined || getUser">
      <v-flex
        align-center
        layout
        py-2
      >
        <v-menu
          :nudge-width="270"
          offset-y
          left
          bottom
        >
          <template #activator="{ on }">
            <v-avatar
              v-if="(getUser && getUser.avatar != null) || (me && me.avatar != null)"
              style="cursor: pointer; border: 1px solid #f6f8f9"
              :tile="false"
              :size="40"
              v-on="on"
            >
              <v-img
                :src="me ? me.avatar : getUser.avatar"
                :lazy-src="me ? me.avatar : getUser.avatar"
                max-height="40"
                contain
              />
            </v-avatar>
            <v-avatar
              v-else
              style="cursor: pointer"
              :tile="false"
              :size="40"
              :color="
                $vuetify.theme.dark
                  ? $vuetify.theme.themes.dark.surface
                  : $vuetify.theme.themes.light.surface
              "
              v-on="on"
            >
              <strong>
                <a>{{ me ? me.name : getUser.name | uppercase | substring(0, 2) }}</a>
              </strong>
            </v-avatar>
          </template>
          <v-card class="me-info-card">
            <v-sheet dense>
              <v-list-item class="me-info">
                <v-list-item-content>
                  <v-list-item-title>{{ me ? me.name : getUser.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ me ? me.obfuscated_email : getUser.obfuscated_email }}
                    <br>
                    <v-chip
                      class="mt-3"
                      small
                      outlined
                      @click="$refs.depositfunds.open()"
                    >
                      {{ $t("toolbar.myBalance") }}:&nbsp;<b>
                        {{ usdAmount }} USD</b>
                    </v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="text-right">
                  <v-btn
                    class="ml-3"
                    x-small
                    text
                    outlined
                    @click="$refs.depositfunds.open()"
                  >
                    {{ $t("globals.depositButton") }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>

              <v-divider />

              <v-list-item @click="$router.push('/profile')">
                <v-list-item-icon>
                  <v-icon>mdi-account-circle-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("toolbar.myProfile")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="$router.push('/security')">
                <v-list-item-icon>
                  <v-icon>mdi-shield-account-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("toolbar.security")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="$router.push('/myinvoices')">
                <v-list-item-icon>
                  <v-icon>mdi-text-box-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("toolbar.myInvoices")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="(me && me.unpaid_invoices) || (getUser && getUser.unpaid_invoices)">
                  <v-icon> mdi-alert-circle </v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-list-item
                v-if="getWhiteLabel"
                @click="$router.push('/affplans')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-vector-triangle</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("toolbar.affiliatePlans")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="getWhiteLabel && isOwner"
                @click="$router.push('/gateways')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-credit-card-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("whitelabel.paymentSettings")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="getWhiteLabel && isOwner"
                @click="$router.push('/members')"
              >
                <v-list-item-icon>
                  <IconCustom
                    name="icn24_users"
                    :color="$vuetify.theme.dark ? '#FFFFFF' : '#7F97AB'"
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("members.title")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip
                    small
                    :color="$vuetify.theme.dark ? '#FFFFFF' : '#7F97AB'"
                    text-color="rgba(0, 0, 0, 0.87)"
                  >
                    {{ $t("globals.beta") }}
                  </v-chip>
                </v-list-item-action>
              </v-list-item>
              <v-list-item
                v-if="getWhiteLabel && isOwner"
                @click="$router.push('/modules/configuration')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-apps</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("whitelabel.modulesSettings")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="isTariffs && !getIsSharingWhitelabels"
                @click="$router.push('/tariffs')"
              >
                <v-list-item-icon>
                  <IconCustom
                    name="icn20_coupon_2"
                    :color="$vuetify.theme.dark ? '#FFFFFF' : '#7F97AB'"
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("whitelabel.tariffSettings")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="chatIDExists"
                @click="onEnableLiveChat"
              >
                <v-list-item-icon>
                  <v-icon>mdi-face-agent</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("toolbar.liveChat")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch
                    v-model="showChat"
                    color="primary"
                    @click.stop=""
                  />
                </v-list-item-action>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>
                    {{
                      $vuetify.theme.dark
                        ? "mdi-moon-waxing-crescent"
                        : "mdi-weather-sunny"
                    }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("toolbar.darkMode")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch
                    v-model="$vuetify.theme.dark"
                    color="primary"
                    @click.stop=""
                  />
                </v-list-item-action>
              </v-list-item>
              <v-divider />
              <v-list-item @click="$router.push('/login')">
                <v-list-item-icon>
                  <v-icon>mdi-power</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("toolbar.logOut")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-sheet>
          </v-card>
        </v-menu>
      </v-flex>
    </v-toolbar-items>
    <helper-deposit-funds ref="depositfunds" />
    <helper-confirm-dialog
      v-if="showInvite"
      :show-dialog="showInvite"
      :text="$t('members.acceptInvate', { whitelabel: dataInvite.whitelabel.name, role: dataInvite.role.name })"
      @closeConfirmDialog="closeConfirmDialog"
    />
  </v-toolbar>
</template>

<script>
import { mapMutations, mapGetters, mapState } from "vuex";
import IconCustom from "@/components/helper/IconCustom.vue";

import ME_QUERY from "@/graphql/queries/Me.gql";
import USER_WHITELABELS_SHORTD_QUERY from "@/graphql/queries/WhiteLabelsShort.gql";
import ROLE_PERMISSIONS_QUERY from "@/graphql/queries/RolePermissions.gql";
import INVITATIONS_QUERY from "@/graphql/queries/Invitations.gql";
import TEAM_MEMEBERS_APROVAL_MUTATION from "@/graphql/mutations/WhitelabelTeamMemberApproval.gql";
import PRICING_START_TRIAL_MUTATION from "@/graphql/mutations/ProviderPricingStartTrial.gql";


const observer = new IntersectionObserver(() => {
      if(document.querySelector("#tidio-chat-iframe")) {
        document.querySelector("#tidio-chat-iframe").className = "iframe-custom";

        if(document.querySelector("#tidio-chat-iframe").contentWindow.document.readyState) {
          setTimeout(() => {
            document.querySelector("#tidio-chat-iframe").contentDocument.body.querySelector("#button-body").addEventListener("click", function() {
            document.getElementById("tidio-chat-iframe").classList.remove("iframe-custom");

            setTimeout(() => {
              document.querySelector("#tidio-chat-iframe").contentDocument.body.querySelector(".exit-chat").addEventListener("click", function() {
                  document.getElementById("tidio-chat-iframe").className = "iframe-custom";
                });
              }, 100)
            });
          }, 100);
        }
      }
    });

export default {
  components: {
    IconCustom
  },
  data() {
    return {
      title: null,
      responsive: false,
      responsiveInput: false,
      showInvite: false,
      countInvite: 0,
      dataInvite: null
    };
  },
  computed: {
    ...mapState("app", ["drawer"]),
    ...mapGetters("app", ["getShowChat"]),
    ...mapGetters("user", ["getUser", "isOwner", "getIsSharingWhitelabels"]),
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
    usdAmount() {
      if (!this.me && !this.getUser) return 0;
      let amount;
      if(this.me) {
        amount = this._.find(this.me.wallet_balance, {
          currency: "USD",
        });
      }
      if(!this.me && this.getUser) {
        amount = this._.find(this.getUser.wallet_balance, {
          currency: "USD",
        });
      }
      
      return amount ? amount.credit : 0;
    },
    chatIDExists() {
      const provider = this.$ls.get("config");
      if (provider.public_config && provider.public_config.tidio_id) {
        return true;
      }
      return false;
    },
    isTariffs() {
      return this.$ls.get("config").has_tariffs
    },
    showChat: {
      get() {
        return this.getShowChat;
      },
      set(val) {
        this.setShowChat(val);
      },
    },
  },
  watch: {
    showChat(val) {
      this.$ls.set("show-chat", val);
      window.tidioChatApi.display(val);
      if(val) {
        setTimeout(() => {
          observer.observe(document.querySelector("#tidio-chat-iframe"));
        }, 100);
      } else {
        observer.disconnect()
      }
    },
    $route(val) {
      this.title = val.name;
    },
    getWhiteLabel: {
      handler(val) {
        if (val && val.owner.uuid !== this.getUser.uuid) {
          const role = this.getUser.roles.find(role => role.whitelabel && role.whitelabel.uuid === val.uuid);
          this.setUserPermissions(null);
          if(role) {
            this.getPermissionRole(role.uuid)
          }
        } else {
          this.setUserPermissions(null);
        }
      },
      deep: true
    },
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);

    // Убираем store.subscribe - используем watch вместо этого

    const onTidioChatApiReady = () => {
      if (this.$ls.get("show-chat") == undefined) {
        this.showChat = false;
      } else {
        this.showChat = this.$ls.get("show-chat");
      }
      window.tidioChatApi.display(this.showChat);
      if(this.showChat && window.tidioChatApi) {
        observer.observe(document.querySelector("#tidio-chat-iframe"));
      }
    };
    if (window.tidioChatApi) {
      window.tidioChatApi.on("ready", onTidioChatApiReady);
    } else {
      document.addEventListener("tidioChat-ready", onTidioChatApiReady);
    }
    const pricingUuid = localStorage.getItem("pricing-uuid")
    if(pricingUuid) {
        this.startPricingTrial(pricingUuid);
    }
  },
  beforeDestroy() {
    observer.disconnect();
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer", "setShowChat", "setLoader", "setNotifier"]),
    ...mapMutations("user", ["setUser", "setUserPermissions", "setIsInvite", "setIsSharingWhitelabels"]),
    ...mapMutations("whitelabel", ["setWhiteLabel"]),
    onEnableLiveChat() {
      this.showChat = !this.showChat;
    },
    onClickBtn() {
      this.setDrawer(!this.drawer);
    },
    onClick() {
      //
    },
    closeConfirmDialog(confirmed) {
      this.showInvite = false;
      if (confirmed) {
        this.approvalTeamMember("active", this.dataInvite.uuid)
      } else {
        this.approvalTeamMember("canceled", this.dataInvite.uuid)
      }
      this.dataInvite = null;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 1367) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    },
    getPermissionRole(roleUuid) { 
        this.loading = true;
        this.setLoader(true)
        const params = {
          whitelabel_uuid: this.getWhiteLabel.uuid,
          role_uuid: roleUuid
        }

        this.$apollo
          .query({
            fetchPolicy: "network-only",
            query: ROLE_PERMISSIONS_QUERY,
            variables: params,
          })
          .then(({loading, data}) => {
            this.loading = loading;
            if(!loading) {
              this.setUserPermissions(data.rolePermissions);
              this.setLoader(false)
            }
          })
          .catch(error => {
            this.errorHandler(error);
            this.loading = false;
            this.setLoader(false)
          });
      },
    approvalTeamMember(confirmed, inviteUuuid) {
      let params = {
        uuid: inviteUuuid,
        status: confirmed,
      }
      this.$apollo
        .mutate({
          mutation: TEAM_MEMEBERS_APROVAL_MUTATION,
          variables: params
        })
        .then(async data => {
          this.responseHandler(data);
          if(this.countInvite < (this.invitations.length - 1)) {
            this.countInvite++;
            this.showInvite = true;
            this.dataInvite = this.invitations[this.countInvite];
          } else {
            this.setIsInvite(false);
            await this.$apollo.queries.me.refetch();
            await this.$apollo.queries.whiteLabels.refetch();
          }
        })
        .catch(error => {
          this.errorHandler(error);
        });
    },
    startPricingTrial(pricingUuid) {
      this.loading = true;
      this.setLoader(true)
      const params = {
        provider_uuid: this.$ls.get('config').uuid,
        pricing_uuid: pricingUuid,
      }

      this.$apollo
        .query({
          fetchPolicy: "network-only",
          query: PRICING_START_TRIAL_MUTATION,
          variables: params,
        })
        .then(({loading, data}) => {
          this.loading = loading;
          if(!loading) {
            this.setNotifier(data.providerPricingStartTrial.message);
            this.setLoader(false);
            localStorage.removeItem("pricing-uuid")
          }
        })
        .catch(error => {
          if (error.graphQLErrors[0].extensions.reason == "ValidationError" && error.graphQLErrors[0].message === "This user already has an active tariff plan") {
            localStorage.removeItem("pricing-uuid");
          }
          this.errorHandler(error);
          this.loading = false;
          this.setLoader(false)
        });
    }
  },
  apollo: {
    whiteLabels: {
      query: USER_WHITELABELS_SHORTD_QUERY,
      fetchPolicy: 'network-only',
      variables() {
        return {
          owner_uuid: this.getUser.uuid,
        };
      },
      result({ loading, data }) {
        if (loading) {
          return;
        }
        if (data.whiteLabels && data.whiteLabels.length > 0) {
          data.whiteLabels.forEach((wl) => {
            wl.modules.forEach((module) => {
              if (
                module.public_config &&
                typeof module.public_config !== "object"
              ) {
                module.public_config = JSON.parse(module.public_config);
                return module;
              }
            });
          });
          const sortCompany = data.whiteLabels;
          sortCompany.sort((x, y) => Number(y.owner.uuid === this.getUser.uuid) - Number(x.owner.uuid === this.getUser.uuid));
          
          const currentWhitelabel = localStorage.getItem('current-whitelabel');

          if (currentWhitelabel) {
            const findWhitelabel = sortCompany.find(item => item.name === currentWhitelabel);
            if(findWhitelabel)  {
              this.setWhiteLabel(findWhitelabel);
            } else {
              this.setWhiteLabel(sortCompany[0]);
            }
          } else {
            this.setWhiteLabel(sortCompany[0]);
          }

          const searchSharing = data.whiteLabels.filter(item => this.getUser.uuid !== item.owner.uuid);
          if(searchSharing.length !== 0 && searchSharing.length === data.whiteLabels.length) {
            this.setIsSharingWhitelabels(true);
          } else {
            this.setIsSharingWhitelabels(false);
          }
          
        } else {
          this.setWhiteLabel(null);
        }
      },
      skip() {
        return !this.getUser;
      },
    },
    me: {
      query: ME_QUERY,
      fetchPolicy: 'network-only',
      skip() {
        return localStorage.getItem("auth-token") === null || this.getUser;
      },
      result(data) {
        if (!data.loading) {
          this.setUser(this.me);
          this.$i18n.locale = this.me.language;
          localStorage.setItem("language", this.$i18n.locale);
          document.tidioChatLang = this.$i18n.locale;
          if (window.tidioChatApi) {
            setTimeout(() => {
              window.tidioChatApi.setVisitorData({
                name: this.getUser.name,
                email: this.getUser.email,
              });
            }, 2000);
          }
        }
      },
    },
    invitations: {
      query: INVITATIONS_QUERY,
      fetchPolicy: 'network-only',
      result({ loading, data }) {
        if (!loading) {
          if(data.invitations.length !== 0) {
            this.showInvite = true;
            this.dataInvite = data.invitations[0];
          }
        }
      },
      skip() {
        return !this.getUser;
      },
    }
  },
};
</script>

<style lang="scss">
#core-toolbar {
  .v-list-item .v-list-item--link {
    &.theme--light {
        color: #96a2ae!important;
        svg {
          fill: #96a2ae!important;
        }
    }
    &.theme--dark {
        svg {
          fill: #fff!important;
        }
    }
  }
  .btn-buy {
    height: 19px;
    margin-left: 5px;
    margin-top: -2px;
  }
  .v-toolbar__title {
    font-size: 0.9rem;
    line-height: 17px;
    margin-top: 4px;
    p {
      margin: 0;
      font-size: 12px;
    }
  }
  a {
    text-decoration: none;
  }
}
.me-info-card {
  padding: 2px !important;
  .v-list {
    padding: 0;
  }
  .v-list-item__title {
    font-weight: 500;
    font-size: 0.9rem;
  }
}
</style>
